function _extends() {
  _extends = Object.assign
    ? Object.assign.bind()
    : function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
  return _extends.apply(this, arguments);
}

import React, { useContext, useState } from "react";
import { Box, Button, ResponsiveContext } from "grommet";
import { TextInput } from "../../Inputs/TextInput";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { getLSValue } from "../../../utils/storage";
import { InputPhone } from "../../Inputs/PhoneInput";
import { makeValidationSchema } from "./makeValidationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
export var PhoneForm = function PhoneForm(_ref) {
  var viewCodeParam = _ref.viewCodeParam,
    changePhoneStatus = _ref.changePhoneStatus,
    setViewCodeField = _ref.setViewCodeField,
    setChangePhoneStatus = _ref.setChangePhoneStatus,
    setNewPhone = _ref.setNewPhone,
    sendNewPhoneCode = _ref.sendNewPhoneCode,
    changeCodeStatus = _ref.changeCodeStatus,
    setChangeCodeStatus = _ref.setChangeCodeStatus;
  var validateForm = makeValidationSchema(setChangePhoneStatus);

  var _useForm = useForm({
      resolver: yupResolver(validateForm),
      shouldFocusError: false,
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    errors = _useForm.formState.errors,
    clearErrors = _useForm.clearErrors;

  var user = localStorage.user && JSON.parse(localStorage.user);
  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);

  var _useState = useState(
      (user == null ? void 0 : user.phone) && "+" + (user == null ? void 0 : user.phone)
    ),
    phone = _useState[0],
    setPhone = _useState[1];

  var handleCodeSend = function handleCodeSend() {
    var phoneSlice = phone.slice(1);
    sendNewPhoneCode({
      phone: phoneSlice,
    });
  };

  var handleInputCode = function handleInputCode(e) {
    var value = e.target.value;

    if (Number(value) && value.length === 4) {
      setNewPhone({
        phone: phone.slice(1),
        phone_code: value,
      });
    } else {
      setChangeCodeStatus("Код должен состоять из 4 цифр");
    }
  };

  var handleResetChange = function handleResetChange() {
    setViewCodeField("");
    setChangePhoneStatus("");
    setChangeCodeStatus("");
  };

  var onSubmit = function onSubmit(_ref2) {
    var phone = _ref2.phone;
    setPhone(phone);
    var phoneSlice = phone.slice(1);
    sendNewPhoneCode({
      phone: phoneSlice,
    });
  };

  return /*#__PURE__*/ React.createElement(
    "form",
    {
      onSubmit: handleSubmit(onSubmit),
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        style: {
          borderRadius: "10px",
          backgroundColor: "#F8F8F8",
        },
        pad: "2rem",
      },
      /*#__PURE__*/ React.createElement(
        Box,
        {
          flex: true,
          direction: isMobileWidth ? "column" : "row",
          gap: "2rem",
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            width: isMobileWidth ? "100%" : "48%",
            gap: "0.5rem",
          },
          /*#__PURE__*/ React.createElement(Controller, {
            name: "phone",
            control: control,
            render: function render(_ref3) {
              var _errors$phone;

              var field = _ref3.field;
              return /*#__PURE__*/ React.createElement(
                InputPhone,
                _extends(
                  {
                    country: "RU",
                    international: true,
                    withCountryCallingCode: true,
                    error:
                      ((_errors$phone = errors.phone) == null ? void 0 : _errors$phone.message) ||
                      changePhoneStatus,
                    id: "profile-tel",
                    name: "phone",
                    value: phone,
                    onFocus: function onFocus() {
                      return clearErrors("phone");
                    },
                    disabled: viewCodeParam,
                  },
                  field
                )
              );
            },
          }),
          viewCodeParam
            ? /*#__PURE__*/ React.createElement(
                Button,
                {
                  onClick: handleResetChange,
                },
                "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C"
              )
            : null
        ),
        !viewCodeParam
          ? /*#__PURE__*/ React.createElement(
              Box,
              {
                flex: true,
                align: "center",
                justify: "center",
                height: "56px",
                margin: {
                  top: !isMobileWidth && "2.275rem",
                },
                pad: {
                  vertical: "0.5rem",
                },
                style: {
                  borderRadius: "5px",
                  backgroundColor: "black",
                  color: "#F8F8F8",
                  cursor: "pointer",
                },
              },
              /*#__PURE__*/ React.createElement(
                Button,
                {
                  type: "submit",
                },
                getLSValue("user", "phone") ? "Изменить телефон" : "Добавить телефон"
              )
            )
          : /*#__PURE__*/ React.createElement(
              Box,
              {
                flex: true,
                direction: "column",
              },
              /*#__PURE__*/ React.createElement(TextInput, {
                error: changeCodeStatus,
                handleChange: handleInputCode,
                name: "code",
                id: "profile-code",
                label: "\u041A\u043E\u0434 \u0438\u0437 \u0421\u041C\u0421",
              }),
              /*#__PURE__*/ React.createElement(
                Box,
                {
                  flex: true,
                  align: "center",
                  justify: "center",
                  height: {
                    max: "35px",
                  },
                  margin: {
                    top: "1rem",
                  },
                  pad: {
                    vertical: "0.5rem",
                  },
                  style: {
                    borderRadius: "5px",
                    backgroundColor: "black",
                    color: "#F8F8F8",
                  },
                },
                /*#__PURE__*/ React.createElement(
                  Button,
                  {
                    onClick: handleCodeSend,
                  },
                  "Отправить код повторно"
                )
              )
            )
      )
    )
  );
};
